module.exports = __webpack_public_path__ + "static/media/step2.9bf91806.png";